module.exports = __webpack_public_path__ + "static/media/hairbrush.f0b4a07c.jpg";